import React from 'react';
import {
  Box,
  Typography,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { GRADIENTS } from '../../../styles/theme';
import { RoiCanvasRef } from '../../../components/RoiCanvas';
import { EditMode } from '../types';

interface RoiWorkModalsProps {
  // ROI ID Dialog
  showRoiIdDialog: boolean;
  setShowRoiIdDialog: (v: boolean) => void;
  newRoiId: string;
  setNewRoiId: (v: string) => void;
  handleConfirmRoiId: () => void;
  setPendingCreatePoints: (v: number[] | null) => void;
  setRoiEditMode: (mode: EditMode) => void;
  roiCanvasRef: React.RefObject<RoiCanvasRef>;
  setCurrentDrawingPoints: (points: number[]) => void;
  // Save Dialog
  showSaveDialog: boolean;
  setShowSaveDialog: (v: boolean) => void;
  handleConfirmSave: () => void;
  selectedRoiFile: string;
}

export const RoiWorkModals: React.FC<RoiWorkModalsProps> = ({
  showRoiIdDialog,
  setShowRoiIdDialog,
  newRoiId,
  setNewRoiId,
  handleConfirmRoiId,
  setPendingCreatePoints,
  setRoiEditMode,
  roiCanvasRef,
  setCurrentDrawingPoints,
  showSaveDialog,
  setShowSaveDialog,
  handleConfirmSave,
  selectedRoiFile,
}) => {
  return (
    <>
      {/* ROI ID 입력 다이얼로그 */}
      <Dialog open={showRoiIdDialog} onClose={() => setShowRoiIdDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 700, color: 'primary.main' }}>
          ROI 번호 입력
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
            새로운 ROI의 번호를 입력하세요
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body1" sx={{ color: 'text.primary', fontWeight: 600 }}>
              ParkingLocations_
            </Typography>
            <TextField
              autoFocus
              size="small"
              type="number"
              label="번호"
              placeholder="1"
              value={newRoiId}
              onChange={(e) => setNewRoiId(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleConfirmRoiId();
                }
              }}
              inputProps={{ min: 1 }}
              sx={{
                flex: 1,
                '& .MuiOutlinedInput-root': {
                  borderColor: 'primary.main',
                }
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            variant="outlined"
            onClick={() => {
              setShowRoiIdDialog(false);
              setPendingCreatePoints(null);
              setNewRoiId('');
              setRoiEditMode(null);
              roiCanvasRef.current?.cancelRoiEdit();
              setCurrentDrawingPoints([]);
            }}
          >
            취소
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmRoiId}
            sx={{
              background: GRADIENTS.primary,
              '&:hover': {
                background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)'
              }
            }}
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>

      {/* 파일 저장 다이얼로그 */}
      <Dialog open={showSaveDialog} onClose={() => setShowSaveDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 700, color: 'primary.main' }}>
          최종 저장
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Typography variant="body1" sx={{ mb: 2, color: 'text.primary' }}>
            최종 저장하시겠습니까?
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            현재 파일: {selectedRoiFile}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            variant="outlined"
            onClick={() => setShowSaveDialog(false)}
          >
            취소
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmSave}
            sx={{
              background: GRADIENTS.primary,
              '&:hover': {
                background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)'
              }
            }}
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
